import { ensureContrast } from "@eventr/common";
import { ColoursObj } from "@eventr/common-storybook";

/**
 * A user-chosen colour (tag, category) lightened or darkened just enough to reach 3:1 against the
 * skin it is drawn on, so pale yellows still show on light skins and deep purples on dark ones.
 * The stored colour is never changed; run it through this only when drawing it.
 *
 * `ColoursObj` is read at call time: `setColourScheme` reassigns it, so a captured value would
 * miss skin switches.
 */
export function onSkin<T extends string | undefined | null>(colour: T, background?: string): T {
  if (!colour) return colour;
  return ensureContrast(colour, background ?? ColoursObj.backgrounds.primary) as T;
}
